// src/lib/supabase/browserClient.ts
import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const SUPABASE_ENV_OK = !!(url && anon);

if (typeof window !== 'undefined') {
  console.warn('[Mystara] Supabase env check', {
    SUPABASE_ENV_OK,
    url: !!url,
    anon: !!anon,
  });
}

export const supabase: SupabaseClient | null = SUPABASE_ENV_OK
  ? createClient(url!, anon!, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true }
    })
  : null;
